import { flagFactory } from '../icon';
import Svg from './se.svg';

export default flagFactory(Svg);
